function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4b4b4b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Lager_2",
  "data-name": "Lager 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "_\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M66.42,76.28H14.83a5,5,0,0,1-5-5V50.56A14.78,14.78,0,0,1,24.56,35.8H68a1.79,1.79,0,1,1,0,3.58H24.56A11.19,11.19,0,0,0,13.38,50.56V71.25a1.45,1.45,0,0,0,1.45,1.45H66.42a1.79,1.79,0,0,1,0,3.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M17.65,41.37a1.37,1.37,0,0,1-.28,0,1.8,1.8,0,0,1-1.49-2.05l3.44-21.9C20.83,7.81,29.87,0,39.48,0H91.77c9.61,0,18.65,7.81,20.16,17.4L113,24h12a6.31,6.31,0,0,1,6.3,6.31v1.72a6.3,6.3,0,0,1-5.92,6.28,1.79,1.79,0,1,1-.22-3.57,2.73,2.73,0,0,0,2.56-2.71V30.33A2.72,2.72,0,0,0,125,27.61H112.71a3.26,3.26,0,0,1-3.24-2.77L108.39,18C107.14,10,99.69,3.58,91.77,3.58H39.48C31.56,3.58,24.11,10,22.86,18l-3.44,21.9A1.79,1.79,0,0,1,17.65,41.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M18.13,38.35H6.3A6.31,6.31,0,0,1,0,32.05V30.33A6.31,6.31,0,0,1,6.3,24H19.81a1.77,1.77,0,0,1,1.36.63,1.8,1.8,0,0,1,.41,1.44L19.89,36.84A1.78,1.78,0,0,1,18.13,38.35ZM6.3,27.61a2.72,2.72,0,0,0-2.72,2.72v1.72A2.72,2.72,0,0,0,6.3,34.77H16.59l1.13-7.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M27.66,65.22A9.18,9.18,0,1,1,36.83,56,9.19,9.19,0,0,1,27.66,65.22Zm0-14.78A5.6,5.6,0,1,0,33.25,56,5.6,5.6,0,0,0,27.66,50.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M31.45,94.15H19.08a5,5,0,0,1-5-5V74.49a1.8,1.8,0,0,1,1.8-1.79H34.7a1.79,1.79,0,0,1,1.79,1.79V89.12A5,5,0,0,1,31.45,94.15ZM17.63,76.28V89.12a1.45,1.45,0,0,0,1.45,1.45H31.45a1.45,1.45,0,0,0,1.46-1.45V76.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M97,85.82a28.51,28.51,0,1,1,28.5-28.51A28.54,28.54,0,0,1,97,85.82Zm0-53.44A24.93,24.93,0,1,0,121.9,57.31,25,25,0,0,0,97,32.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M128.18,94.78H128a6.18,6.18,0,0,1-4.49-2.06L111.8,79.8a1.78,1.78,0,0,1-.46-1.37,1.76,1.76,0,0,1,.7-1.26,25,25,0,0,0,4.79-4.8,1.81,1.81,0,0,1,1.26-.7,1.77,1.77,0,0,1,1.37.46l12.93,11.73h0a6.28,6.28,0,0,1-4.21,10.92Zm-12.46-16,10.46,11.53a2.69,2.69,0,1,0,3.8-3.81L118.45,76.05A29.42,29.42,0,0,1,115.72,78.79Z"
})));

function SvgCarSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 134.45 94.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSearch);
export default __webpack_public_path__ + "static/media/car-search.6a0a56c9.svg";
export { ForwardRef as ReactComponent };